import { useState, useMemo } from "react";
import { FormattedMessage as FM } from "react-intl";

import FormField from "./FormField";
import Popover from "componentsv2/widgets/Popover";
import { cn, colors } from "tools/ui";
import { theme } from "theme/theme";
// import intl from "i18n/messages";

const style = "w-full py-2 px-2";

/**
 *
 * @param {*} props -
 * @param {Boolean} readOnly -
 * @param {String} type -
 * @param {String} label -
 * @param {String} name -
 * @param {String} placeholder -
 * @param {String} value -
 * @param {Function} onChange -
 * @param {Boolean} translate -
 * @returns Component Char
 */

function Char(props) {
  const {
    name,
    data,
    label,
    readOnly,
    placeholder,
    onChange,
    validate,
    icon,
    uppercase,
    colSpan,
    withoutSpaces,
    specialCharacters,
    mode,
    model,
  } = props;

  const [errorMsg, setErrorMsg] = useState(null);
  const popoverShow = useMemo(() => ({ value: !!errorMsg }), [!!errorMsg]);

  let _color = props.color ?? "bg-white";

  if (readOnly) {
    _color = colors.readOnly;
  }

  function removeSpaces(value) {
    return value.replace(" ", "");
  }

  function handleChange(event) {
    let _value = event.target.value;
    if (uppercase) {
      _value = _value.toUpperCase();
    }
    if (validate) {
      const result = validate({ value: _value });
      if (result === true) {
        setErrorMsg(null);
      } else if (typeof result === "string") {
        setErrorMsg(result);
      } else {
        return;
      }
    }
    if (withoutSpaces) {
      _value = removeSpaces(_value);
    }

    data.value = _value;
    if (onChange) {
      onChange(name, _value);
    }
  }

  function onBlur(event) {
    const _value = event.target.value;
    if (validate) {
      const result = validate({ value: _value, context: "onblur" });
      if (result === true) {
        setErrorMsg(null);
      } else if (typeof result === "string") {
        setErrorMsg(result);
      } else {
        data.value = "";
        return;
      }
    }
    if (onChange) {
      onChange(name, _value);
    }
  }

  return (
    <FormField
      id={name}
      label={label}
      name={name}
      required={props.required}
      colspan={colSpan}
      mode={mode}
      model={model}
    >
      <div className="relative">
        <input
          key={name}
          id={name}
          name={name}
          type="text"
          className={cn(
            _color,
            style,
            theme.textColor,
            theme.border,
            theme.input.height,
          )}
          value={data}
          onChange={handleChange}
          onBlur={onBlur}
          disabled={readOnly ?? false}
          placeholder={placeholder ?? ""}
        />
        {errorMsg && (
          <Popover
            show={popoverShow}
            className={
              "bg-gray-50/90! z-50 min-w-64 mt-1 rounded-sm! shadow-xl border  border-neutral-300"
            }
          >
            <p className="text-red-600 text-xs ">
              <FM id={errorMsg} />
            </p>
          </Popover>
        )}
      </div>
      {icon || null}
    </FormField>
  );
}

export default Char;
